<template>
    <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('components.breadcrumb.home') }}</el-breadcrumb-item>
            <el-breadcrumb-item
                v-for="(item,index) in breadArray"
                :key="index"
                :to="item.path ? { path: item.path } : ''"
                >
                {{ getItemName(item) }}
            </el-breadcrumb-item>
            
        </el-breadcrumb>
        <el-button @click='goBack' icon="el-icon-back" type="text">{{ $t('components.breadcrumb.back') }}</el-button>
    </div>
</template>
<script>
export default {
    props:{
        breadArray: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1)
        },
        getItemName(item) {
            if (item.i18n && this.$te(item.i18n)) {
                return this.$t(item.i18n)
            }
            return item.name
        }
    }
}
</script>
<style lang="scss" scoped>
.breadcrumb{
    margin: 16px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    ::v-deep .el-button {
        font-size: 16px;
    }
    ::v-deep .el-breadcrumb {
        font-size: 16px;
    }
}
</style>
